import { render, staticRenderFns } from "./SchoolNameLookup.vue?vue&type=template&id=14eb9b52&scoped=true&"
import script from "./SchoolNameLookup.vue?vue&type=script&lang=js&"
export * from "./SchoolNameLookup.vue?vue&type=script&lang=js&"
import style0 from "./SchoolNameLookup.vue?vue&type=style&index=0&id=14eb9b52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb9b52",
  null
  
)

export default component.exports